import { createElement, type ComponentProps } from 'react'
import { Document as PdfDocument, Page as PdfPage, pdfjs } from 'react-pdf'

// One worker config for every pdf.js consumer (bundled via Vite's worker handling).
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString()

export const PASSWORD_PROTECTED_MESSAGE = 'This PDF is password-protected, so it cannot be shown here.'

/**
 * react-pdf asks for a password with the browser's native prompt() by default, which blocks the page (CLAUDE.md:
 * never native dialogs). A password-protected PDF instead fails to load: handing pdf.js an Error rejects the load,
 * so the Document's onLoadError / error placeholder shows.
 */
export const refusePassword: NonNullable<ComponentProps<typeof PdfDocument>['onPassword']> =
  callback => (callback as (p: string | Error) => void)(new Error(PASSWORD_PROTECTED_MESSAGE))

/**
 * react-pdf 11 loads through Suspense by default. With no Suspense boundary that suspends the whole app while a PDF
 * loads — and a protected PDF's load waits on the password modal, which is itself one of the suspended updates, so it
 * never appears. <c>suspense: false</c> loads in an Effect instead and shows the <c>loading</c> prop meanwhile.
 */
export function Document(props: ComponentProps<typeof PdfDocument>) {
  return createElement(PdfDocument, { onPassword: refusePassword, suspense: false, ...props })
}

export function Page(props: ComponentProps<typeof PdfPage>) {
  return createElement(PdfPage, { suspense: false, ...props })
}

export { pdfjs }
